var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mobile-sidebar", class: _vm.isOpen ? "sidebar-open" : "" },
    [
      !_vm.isOpen
        ? _c("menu-icon", {
            on: {
              click: function ($event) {
                _vm.isOpen = true
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isOpen
        ? _c(
            "p",
            { staticClass: "close-icon" },
            [_c("close-icon", { on: { click: _vm.handleClose } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "slide", mode: "out-in" } },
        [
          _vm.isOpen
            ? _c("sidebar-nav", {
                directives: [
                  {
                    name: "on-clickaway",
                    rawName: "v-on-clickaway",
                    value: _vm.handleClose,
                    expression: "handleClose",
                  },
                ],
                staticClass: "sidebar-nav",
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }